import { defineMessages } from 'react-intl';

export default defineMessages({
    alvaWouldLikeTo: {
        id: 'app.signup.instructions.alvaWouldLikeTo',
        defaultMessage: 'Alva would like to'
    },
    continue: {
        id: 'app.signup.instructions.continue',
        defaultMessage: 'Continue'
    },
    warning: {
        id: 'app.signup.instructions.warning',
        defaultMessage: 'You must approve the required consents to continue'
    }
});
